// src/LogoLink.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import './LogoLink.css';

export const LOGO_DESTINATION = '/members';

// The one TickrTrends logo. Always an in-app link to /members; the route
// guard there sends members to Portfolio Intelligence, signed-in non-members
// to /subscribe and everyone else to /signup.
//
// `className` positions it for its host (nav bar, card, footer); the look of
// the mark itself lives in LogoLink.css.
const LogoLink = ({ className = '', iconSize = 22 }) => (
  <Link to={LOGO_DESTINATION} className={`logo-link ${className}`.trim()}>
    <TrendingUp size={iconSize} className="logo-link__icon" aria-hidden="true" />
    <span className="logo-link__text">TickrTrends</span>
  </Link>
);

export default LogoLink;
